module.exports = __webpack_public_path__ + "__assets__/img/credential-bg.059dfdfd.png";